export const GQL_QUERIES = {
    
    getSelfService: `
      query GetSelfService {
        getSelfService{
          selfService
        }
      }
    `,
    getSelfServiceViewOnly: `
      query getSelfServiceViewOnly($emplid: String!) {
        getSelfServiceViewOnly(emplid: $emplid) {
          selfService
        }
      }
    `,
    
    personSearch: `
    query personSearch($input: PersonSearchInput!) {
        personSearch(input: $input) {
          columns {
            field
            flex
            headerName
            renderCell
            width
            default
          }
          results
        }
      }
    `,

    submitStudentDecision: `
      mutation submitStudentDecision($decision: String!) {
        submitStudentDecision(decision: $decision) {
          selfService
        }
      }    
    `,

    // U9b — Scholars preferencing (U4). Owner-scoped (resolver enforces ownership). alternateOptIn
    // is submitted together with the ranked preferences (single op — matches the backend schema).
    // term is OPTIONAL — resolved server-side from the applicant's Scholars records (CFG-FR-11).
    submitScholarsPreferences: `
      mutation submitScholarsPreferences($applicantEmployeeId: String!, $term: String, $rankings: [ScholarsPreferenceInput!]!, $alternateOptIn: Boolean!) {
        submitScholarsPreferences(applicantEmployeeId: $applicantEmployeeId, term: $term, rankings: $rankings, alternateOptIn: $alternateOptIn) {
          status
        }
      }
    `,

    // has489 — student-facing list of OPEN Scholars programs for the current cycle term.
    // Term resolved server-side. has607 — returns ALL programs for the preferencing form, each
    // tagged with isOpen so closed programs can render as non-selectable "(Closed)" options.
    getOpenScholarsPrograms: `
      query getOpenScholarsPrograms {
        getOpenScholarsPrograms {
          subProgramId
          term
          label
          isOpen
        }
      }
    `,

    // has505 — student-facing read-only view of their submitted preferences.
    // Owner-scoped (resolver enforces ownership). Term optional — resolved server-side.
    getScholarsPreferences: `
      query getScholarsPreferences($applicantEmployeeId: String!, $term: String) {
        getScholarsPreferences(applicantEmployeeId: $applicantEmployeeId, term: $term) {
          subProgramId
          rank
          status
          alternateOptIn
        }
      }
    `

    // NOTE: standalone alternate opt-in and withdraw operations do NOT exist in the backend schema.
    // - alternate opt-in is folded into submitScholarsPreferences (above).
    // - withdraw (D1) was deferred at U4 (TODO-U4-1); tracked as TODO-U9-GAP-WITHDRAW in gap-check.md.
  };
  